import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const trackPageView = () => {
  try {
    let vid = localStorage.getItem("radiate_vid");
    if (!vid) {
      vid =
        (window.crypto && window.crypto.randomUUID && window.crypto.randomUUID()) ||
        `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem("radiate_vid", vid);
    }
    axios
      .post(`${API}/track`, {
        visitor_id: vid,
        path: window.location.pathname,
        referrer: document.referrer || "direct",
      })
      .catch(() => {});
  } catch (e) {
    /* no-op */
  }
};
